import React from 'react';

import Textarea from 'react-textarea-autosize';

const TextareaInput = (props) => {
	const {
		nameField,
		className,
		onChange,
		required,
		valueField,
		question,
		classContainer,
		disabledField,
		messageErrorField,
		meta,
	} = props;

	return (
		<div className={`component-question-data p-0 mb-4 ${classContainer} ${meta.auto_size ? '' : 'para-finalizar'}`}>
			{meta.finalizar ? <h3>Estamos quase terminando. <span role="img" aria-label="Feliz">🤗</span></h3> : ''}

			<p>
				{question}
				{required ? <span className="required">*Campos de preenchimento obrigatório.</span> : ''}
			</p>

			{meta.finalizar ? <p className="description">No campo abaixo, insira outras informações que achar relevantes para a sua campanha e não se esqueça de clicar no botão &quot;Enviar&quot; para finalizar este questionário.</p> : ''}

			{ meta.auto_size
				? (
					<Textarea
						className={`${className} form-control noresize`}
						name={nameField}
						value={valueField}
						onChange={onChange}
						disabled={disabledField}
					/>
				)
				: (
					<textarea
						className={`${className} form-control noresize`}
						name={nameField}
						rows="6"
						value={valueField}
						onChange={onChange}
						disabled={disabledField}
					/>
				)
			}

			<div className="help-block">{messageErrorField}</div>

			<p className="mt-1 description">{meta.description}</p>

			{ meta.finalizar
				? (
					<div className="attention">
						<p className="text-red">
							Fique atento no seu e-mail para verificar as próximas etapas da sua campanha.
						</p>
					</div>
				) : ''
			}

		</div>
	);
};

export default TextareaInput;
